import {
  Alert,
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import CustomIcon from "components/CustomIcon";
import Status from "components/Status";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanAllProgramData } from "store/actions/program";
import { formatDate, fullName } from "utils/common";

const StyledAlert = styled(Alert)(() => ({
  cursor: "pointer",
  border: "1px solid #E0E4EA",
  borderRadius: "8px",
  marginBottom: "8px",
  paddingTop: "0px",
  paddingBottom: "0px",
  "&:last-child": {
    marginBottom: "0px",
  },
  ".MuiAlert-icon": {
    display: "none",
  },
  ".MuiAlert-action": {
    alignItems: "center",
  },
  ".MuiAlert-message": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: "#4F5668",
    fontSize: "14px",
  },
}));

const ClientListBody = ({ toggleDeleteModel, client }) => {
  const dispatch = useDispatch();
  const naviagate = useNavigate();
  const { type } = useSelector((state) => state.user.userDetails);
  const actionButtons = (
    <>
      <IconButton
        color="inherit"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          naviagate(`/clients/${client._id}`);
        }}
      >
        <CustomIcon
          iconSrc="/assets/logo/detail_icon.svg"
          iconHoverSrc="/assets/logo/detail_icon_hover.svg"
        />
      </IconButton>
      <IconButton
        color="info.main"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          toggleDeleteModel(client);
        }}
      >
        <CustomIcon
          iconSrc="/assets/logo/trash_icon.svg"
          iconHoverSrc="/assets/logo/trash_icon_hover.svg"
        />
      </IconButton>
    </>
  );

  return (
    <StyledAlert
      variant="outlined"
      severity="info"
      onClick={() => {
        dispatch(cleanAllProgramData());
        naviagate(`/clients/${client._id}`);
      }}
    >
      {/* Mobile card layout */}
      <Box sx={{ display: { xs: "flex", sm: "none" }, width: "100%", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography fontWeight={600} fontSize="14px" noWrap>
            {fullName(client.first_name, client.last_name)}
          </Typography>
          <Typography fontSize="12px" color="#757E97" noWrap>
            {client.email}
          </Typography>
          <Box sx={{ mt: 0.5 }}>
            <Status type={client.status} label={client.status} />
          </Box>
        </Box>
        <Box sx={{ flexShrink: 0, display: "flex" }}>{actionButtons}</Box>
      </Box>

      {/* Desktop row layout */}
      <Grid container sx={{ display: { xs: "none", sm: "flex" } }}>
        <Grid
          item
          sm={4}
          sx={{ display: "flex", gap: "10px", alignItems: "center" }}
        >
          {fullName(client.first_name, client.last_name)}
        </Grid>
        <Grid item sm={3} sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title={client.email} arrow>
            <Typography
              mr={2}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                maxWidth: "100%",
                fontSize: "14px",
              }}
            >
              {client.email}
            </Typography>
          </Tooltip>
        </Grid>
        <Grid
          item
          sm={2}
          sx={{
            display: "flex",
            alignItems: "center",
            textTransform: "capitalize",
          }}
        >
          {formatDate(client.created_on)}
        </Grid>
        <Grid item sm={2} sx={{ display: "flex", alignItems: "center" }}>
          <Status type={client.status} label={client.status} />
        </Grid>
        <Grid item sm={1} sx={{ textAlign: "right" }}>
          {actionButtons}
        </Grid>
      </Grid>
    </StyledAlert>
  );
};

export default ClientListBody;
